// this array determines if the tenant the logged in user belongs to can access higher level functions in Cumulus
// Currently mostly used for hardware order fxns and hardware assets, as well as contracts and software
// It is tied to their EMAIL address domain NOT their Cumulus tenant id
// Add new values with caution

const rawDomains = process.env.REACT_APP_AUTHORIZED_DOMAINS_FOR_TENANT_CHANGE || '';
const authorizedDomainsForTenantChange = rawDomains ? rawDomains.split(',') : [];


module.exports = authorizedDomainsForTenantChange;